import { useState, useRef, useEffect } from "react";
import "./CSS/TextFile.css";

export default function TextFile({ content = "", onChange }) {
  const [text, setText] = useState(content.replace(/\\n/g, "\n"));
  const textareaRef = useRef(null);

  const handleChange = (e) => {
    const newText = e.target.value;
    setText(newText);
    if (onChange) onChange(newText);
  };
  useEffect(() => {
    setText(content.replace(/\\n/g, "\n"));
  }, [content]);

  // 🔧 Auto-grow textarea height as content increases
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // reset
      textarea.style.height = textarea.scrollHeight + "px"; // expand to fit
    }
  }, [text]);

  const lineNumbers = text.split("\n").map((_, i) => i + 1);

  return (
    <div className="textfile-container">
      <div className="textfile-content">
        <div className="line-numbers">
          {lineNumbers.map((n) => (
            <div key={n}>{n}</div>
          ))}
        </div>
        <textarea
          ref={textareaRef}
          className="textfile-editor"
          value={text}
          onChange={handleChange}
          spellCheck="false"
        />
      </div>
    </div>
  );
}
